"use strict";

import uniqid from "uniqid";

const uniqueId = function() {
    return `${Math.floor(new Date().getTime() / 1000)}${uniqid()}`;
}

export default uniqueId;